import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  ["Media Kit", "/files/mediakit.zip"],
  ["Problem", "/#about"],
  ["Solution", "/#solution"],
  ["Tokenomics", "/#tokenomics"],
  [
    "Buy Now",
    "https://app.uniswap.org/#/swap?outputCurrency=0xf5d20bae62a50c2a0953e054e9544d7906114df9&chain=mainnet",
  ],
  [
    "View Chart",
    "https://www.dextools.io/app/ether/pair-explorer/0xd017ea99f60535e5e0f87f997968ad59c6a61b06",
  ],
  ["Join Telegram", "https://t.me/Poodlejoin"],
];

const checkSticky = "";
const Menu = () => {
  // const [useCheckSticky, setCheckSticky] = useState("no-sticky");
  // useEffect(() => {
  //   window.addEventListener("scroll", isSticky);
  //   return () => {
  //     window.removeEventListener("scroll", isSticky);
  //   };
  // });
  // const isSticky = (e) => {
  //   const scrollTop = window.scrollY;
  //   scrollTop >= 20 ? setCheckSticky("sticky") : setCheckSticky("No-sticky");
  // };
  return (
    <MenuContainer
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="300"
      data-aos-offset="0"
      data-aos-duration="1000"
    >
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
